import {createSlice} from '@reduxjs/toolkit';

export interface AerialViewState {
  center: number[];
  zoom: number;
  rotation: number;
  basemap: string;
}

export interface SceneCameraState {
  camera: string;
  fov: number;
  angles: number[];
  lookat: number[];
  orbit: number[];
  pivot: number[];
}

interface CameraState {
  transform: string;
  adjustments: object,
  height: number;
  aerialState: AerialViewState;
  sceneState: SceneCameraState;
}

export const initialAerialState = {
  center: null,
  zoom: null,
  rotation: null,
  basemap: null
} as AerialViewState;

export const initialSceneState = {
  camera: null,
  fov: null,
  angles: null,
  lookat: null,
  orbit: null,
  pivot: null
} as SceneCameraState;

export const cameraStateSlice = createSlice({
  name: 'camera',
  initialState: {
    transform: null,
    adjustments: {},
    height: 3.0,
    aerialState: initialAerialState,
    sceneState: initialSceneState
  } as CameraState,
  reducers: {
    changeCameraTransform: (state, action) => {
      state.transform = action.payload;
    },
    changeCameraState: (state, action) => {
      state.sceneState = action.payload;
    },
    changeCameraHeight: (state, action) => {
      state.height = action.payload;
    },
    changeBasicAdjustments: (state, action) => {
      state.adjustments = action.payload;
    },
    changeSavedAerialState: (state, action) => {
      state.aerialState = action.payload;
    },
  }
});

export const {
  changeCameraState,
  changeCameraTransform,
  changeCameraHeight,
  changeBasicAdjustments,
  changeSavedAerialState
} = cameraStateSlice.actions;

export default cameraStateSlice.reducer;

export const selectCameraHeight = state => state.camera.height;
export const selectActiveCamera = state => state.camera.sceneState.camera;
export const selectCameraState = state => state.camera.sceneState;
export const selectCameraTransform = state => state.camera.transform;
export const selectBasicAdjustments = state => state.camera.adjustments;
export const selectSavedAerialState = state => state.camera.aerialState;